import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import { useFormik } from "formik";
import { forgotPasswordSchema } from "../utils/validations";
import { VerificationTokenType } from "../types";
import { useGenerateMutation } from "../store";
import { useNavigate } from "react-router-dom";
import Logo from "../components/common/Logo";

const ForgotPassword = () => {
  const [generateCode, { isLoading }] = useGenerateMutation();
  const navigate = useNavigate();

  const handleSubmitForm = async (values: { email: string }) => {
    const data = {
      email: values.email,
      type: VerificationTokenType.RESET_PASSWORD,
    };

    const result = await generateCode(data);
    if (!result.error) {
      navigate(
        `/auth/verify-code?email=${values.email}&type=${VerificationTokenType.RESET_PASSWORD}`
      );
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<{ email: string }>({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPasswordSchema,
    onSubmit: handleSubmitForm,
  });

  return (
    <div className="w-full flex min-h-screen">
      <div className="w-full md:w-1/2 h-full flex flex-col items-center mt-12 p-4 gap-3">
        <Logo />
        <div>
          Saisissez votre email et vous recevrez un code de verification par
          email
        </div>
        <TextField
          id="email"
          value={values.email || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched}
          errors={errors}
          placeholder="Email"
        />
        <Button
          className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white"
          disabled={isSubmitting || isLoading}
          type="submit"
          onClick={handleSubmit}
        >
          Envoyer
        </Button>
      </div>
      <img
        className="hidden md:block w-1/2 h-full object-cover"
        src="/assets/images/auth-banner.jpg"
      />
    </div>
  );
};

export default ForgotPassword;
